<template>
  <div class="notice-detail container">
    <div class="title">{{info.title}}</div>
    <div class="sub-title">
      <span class="time">{{info.publish_time | formatTime}}</span>
      <span v-if="info.publisher">{{` ${info.publisher} 发布`}}</span>
    </div>
    <div class="content gc-content">
      <markdownBeautiful :data="info.content_html" />
      <div class="tip-container">
        <tgoLoading v-if="loading" color="#D7B375" />
        <div class="wrapper" v-if="!loading&&!Object.keys(info).length">
          <span class="iconfont icon-empty"></span>
          <span class="warn-tip">暂无公告与动态</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import markdownBeautiful from '@/components/markdown-beautiful'
import tgoLoading from '@/components/loading'

import moment from 'moment'

import service from '@/service'

export default {
  data () {
    return {
      typeArr: {
        1: '官方公告',
        2: '新闻动态',
        4: '干货文章',
        8: '其他'
      },
      info: {},
      loading: false
    }
  },
  components: {
    markdownBeautiful,
    tgoLoading
  },
  props: ['id'],
  created () {
    this.getNoticeSingleNews(this.id)
  },
  methods: {
    getNoticeSingleNews (id) {
      if (this.loading) return
      this.loading = true
      service.getNoticeSingleNews({ id })
        .then(data => {
          this.loading = false
          this.info = data

          document.title = `${data.title} | TGO 鲲鹏会`
        })
        .catch(() => { this.loading = false })
    }
  },
  filters: {
    formatTime: function (publishTime) {
      return moment.unix(Number(publishTime)).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss">
@import '../../../style/bulma/app.sass';

.notice-detail {
  padding: 30px 0px;
  .title {
    line-height: 30px;
    margin-bottom: 15px;
    color: #3E404A;
    font-size: 22px;
    // @include limit-line-numbers(2);
  }
  .sub-title {
    margin-bottom: 26px;
    font-size: 14px;
    color: #a09e9e;
    line-height: 1;
    .type {
      color: #D7B375;
    }
  }
  .content {
    text-align: justify;
    font-size: 17px;
    line-height: 30px;
    position: relative;
  }
}

// 暂无活动
.tip-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  top: 43%;
  transform: translateY(-50%);
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .iconfont.icon-empty {
      font-size: 80px;
      color: rgba($primary3, 0.25);
    }
    .warn-tip {
      font-size: 18px;
      color: rgba(178, 178, 178, 1);
    }
  }
}

</style>
